module.exports = __webpack_public_path__ + "img/im_scrollfeature_14.9b264a73.jpg";